export default "__VITE_ASSET__CyUS1UMM__"